import { Component, OnInit} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-modals-confirm',
  templateUrl: './modals-confirm.component.html',
  styleUrls: ['./modals-confirm.component.css']
})
export class ModalsConfirmAccessEmployeeContractorComponent implements OnInit {
  bodyTranslation: string
  constructor( public dialogRef: MatDialogRef<ModalsConfirmAccessEmployeeContractorComponent>, private translate: TranslateService) { }

  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
  ngOnInit(){

  }

}

